module.exports = __webpack_public_path__ + "img/mbBanner16.6052c28d.png";